// extracted by mini-css-extract-plugin
module.exports = {"root":"checkbox-name_root__hSnYQ"};